export default __webpack_public_path__ + "static/media/app_battle.e5fea59e.svg";